import { useModalStore } from '@/store/modalStore';
import { useUserDataStore } from '@/store/userDataStore';
import { getPopUpsForUser } from '@/services/admin_features/popupServices';
import PopupComponent from '@/components/AdminComponents/MarketingBanners/PopupComponent.vue';

let hasRunThisSession = false;

const TriggerModal = async () => {
  if (hasRunThisSession) return;
  hasRunThisSession = true;

  const userDataStore = useUserDataStore();
  // If any quiz trigger exists, skip showing popups entirely
  if (userDataStore.triggers && userDataStore.triggers.length > 0) return;

  const modalStore = useModalStore();

  try {
    const response = await getPopUpsForUser();
    const popups = response?.data || [];

    const dismissedRaw = localStorage.getItem('dismissedPopups') || '{}';
    const dismissedMap: Record<number, string> = JSON.parse(dismissedRaw);

    const now = new Date();

    for (const popup of popups) {
      if (popup.enabled !== 1) {
        continue;
      }

      const dismissedAt = dismissedMap[popup.id];
      if (dismissedAt) {
        const dismissedDate = new Date(dismissedAt);
        const daysSinceDismiss = (now.getTime() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
        if (daysSinceDismiss < 30) {
          continue;
        } else {
          delete dismissedMap[popup.id]; // expired, allow again
        }
      }

      // Double check QuizComponent modal not open (optional safety)
      const current = modalStore.component?.value;
      if (current?.__name === 'QuizComponent') return;

      localStorage.setItem('dismissedPopups', JSON.stringify(dismissedMap));
      setTimeout(() => {
        modalStore.openModal({
          title: '',
          description: '',
          component: PopupComponent,
          props: { color: 'primary' },
          options: { noPadding: true, whiteIcon: true },
        });
      }, 5000); // 5-second delay
      return;
    }
  } catch (err) {
    // Fail silently
  }
};

export { TriggerModal };